import React       from 'react';

import Context from '../../../../context';

import { useTranslation } from 'react-i18next';

import { CustomModal, CustomButton2, ResponsiveView } from '../../../../components';

import './index.sass';
import api from "../../../../api";

const Update: React.FC = (): React.ReactElement => {

  const { t } = useTranslation();

  const { showModal, setShowModal,refetch, setIsLoading, updateFunction, isLoading, selectedDriver } = React.useContext(Context.DriverScreen);

  async function submitHandler(): Promise<void> {
    setIsLoading!(true);
    await api.get.administrator.removeIsAproveDriver(selectedDriver?._id);
    refetch();
    setShowModal!('NONE');
    setIsLoading!(false);
  }

  function handleCancel(): void {
    setShowModal!('NONE');
  }

  return (
    <section id="parent-update-modal-container">
      <form onSubmit={submitHandler}>
        <CustomModal onClose={() => setShowModal!("NONE")} open={showModal === "REMOVE_ARCHIVE"}>
          <ResponsiveView.Container className="create-form-content">
            <ResponsiveView.Row className="form-row">
              <p>آیا تأیید می‌کنید که کاربر «{`${selectedDriver?.firstName} ${selectedDriver?.lastName}`}» از آرشیو خارج شود؟</p>
            </ResponsiveView.Row>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column large={3} medium={4} small={6} className="form-colum">
                <CustomButton2 isLoading={isLoading} onClick={handleCancel} title={t("cancel")} type={'danger'}/>
              </ResponsiveView.Column>
              <ResponsiveView.Column large={3} medium={4} small={6} className="form-colum">
                <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t("submit")}/>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
          </ResponsiveView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Update;
